<template>
  <page-header title="Перевозка снегоходов"/>
  <div class="public-container public-container-mobile shipping-types">
    <div id="about" class="shipping-types-banner-wrapper">
      <div class="shipping-types-banner mb-30">
        <public-card-info img-url="/images/pages/shipping-type/snowmobile.png">
          <div class="shipping-types-card-text">
            {{ content.blocks?.about.cardText }}
          </div>
        </public-card-info>
        <public-card-attention :text="content.blocks?.about.attention" class="mt-30"/>
      </div>

      <p>
        {{ content.blocks?.about.description }}
      </p>
      <div class="shipping-types-block">
        <h2 class="vz-text-align-left snowmobile-letter-spacing">
          {{ content.blocks?.about.title }}
        </h2>

        <div v-for="item of aboutItems" class="shipping-types-info-item">
          <vz-icon
              :url="item.icon"
              variant="primary"
              no-masked-icon
          />
          <div>
            <div class="shipping-types-info-item-title">{{ item.title }}</div>
            <p>{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>

    <div id="peculiarities" class="shipping-types-block">
      <h2 class="vz-text-align-left">
        {{ content.blocks?.peculiarities.title }}
      </h2>
      <p>{{ content.blocks?.peculiarities.description }}</p>
    </div>

    <shipping-types-buttons />

    <div class="shipping-types-block-grid">
      <div class="shipping-types-block-grid-main">
        <vz-icon
            url="/svg/snowmobile.svg"
            no-masked-icon
            size="112"
            variant="white"
        />
        <p>{{ content.blocks?.peculiarities.itemsTitle }}</p>
      </div>
      <public-info-grid-block
          v-for="(item, index) of items"
          :key="index"
          :item="item"
          rounded-style
      />
    </div>

    <shipping-types-chain current="snowmobile" />
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicCardInfo from '~/components/public/public-card-info.vue'
import PublicCardAttention from '~/components/public/public-card-attention.vue'
import PublicInfoGridBlock from '~/components/public/public-info-grid-block.vue'
import ShippingTypesButtons from '~/components/public/shipping-types/shipping-types-buttons.vue'
import ShippingTypesChain from '~/components/public/shipping-types/shipping-types-chain.vue'
import {getPageContent} from '~/api/content';

const content = await getPageContent('/shippingtypes/snowmobile')

const aboutItems = computed(() => [
  {
    icon: '/svg/vz-phone-success-2.svg',
    title: content.blocks?.about.mobileTitle,
    text: content.blocks?.about.mobileText
  },
  {
    icon: '/svg/vz-person.svg',
    title: content.blocks?.about.lkTitle,
    text: content.blocks?.about.lkText
  },
  {
    icon: '/svg/vz-monitor.svg',
    title: content.blocks?.about.siteTitle,
    text: content.blocks?.about.siteText
  },
  {
    icon: '/svg/phone-in-talk.svg',
    title: content.blocks?.about.phoneTitle,
    text: content.blocks?.about.phoneText
  },
  {
    icon: '/svg/vz-signature.svg',
    title: content.blocks?.about.terminalTitle,
    text: content.blocks?.about.terminalText
  },
])

const items = computed(() => [
  {
    icon: {
      url: '/svg/icon/vz-home.svg'
    },
    title: content.blocks?.peculiarities.addressDeliveryTitle,
    text: content.blocks?.peculiarities.addressDeliveryText
  },
  {
    icon: {
      url: '/svg/package.svg'
    },
    title: content.blocks?.peculiarities.wrappingTitle,
    text: content.blocks?.peculiarities.wrappingText
  },
  {
    icon: {
      url: '/svg/box-transportation.svg'
    },
    title: content.blocks?.peculiarities.pprTitle,
    text: content.blocks?.peculiarities.pprText
  },
  {
    icon: {
      url: '/svg/crane.svg'
    },
    title: content.blocks?.peculiarities.transportTitle,
    text: content.blocks?.peculiarities.transportText
  },
])
</script>

<style lang="scss" scoped>
.snowmobile-letter-spacing {
  letter-spacing: -0.2px;
}

.shipping-types-block-grid {
  @media screen and (min-width: $pub-sm + 1) {
    margin: 70px auto;
    grid-template-columns: repeat(6, 1fr);
    gap: 20px;
    > div {
      &:nth-child(1) {
        grid-area: 1 / 1 / 2 / 3;
      }

      &:nth-child(2) {
        grid-area: 1 / 3 / 2 / 5;
      }

      &:nth-child(3) {
        grid-area: 1 / 5 / 2 / 7;
      }

      &:nth-child(4) {
        grid-area: 2 / 1 / 3 / 4;
      }

      &:nth-child(5) {
        grid-area: 2 / 4 / 3 / 7;
      }
    }
  }

  @media screen and (max-width: $pub-md) {
    &-main {
      padding: 30px 35px;
    }
  }

  @media screen and (max-width: $pub-sm) {
    grid-template-columns: repeat(6, 1fr);
    &-main {
      padding: 30px;
    }
    > div {
      &:nth-child(1) {
        grid-area: 1 / 1 / 2 / 4;
      }

      &:nth-child(2) {
        grid-area: 1 / 4 / 2 / 7;
      }

      &:nth-child(n+3) {
        grid-column-start: 1;
        grid-column-end: 7;
      }
    }
  }

  @media screen and (max-width: $pub-xs) {
    grid-template-columns: 1fr;
    &-main {
      padding: 30px 15px;
    }
    > div {
      grid-area: unset !important;
      grid-column-start: 1;
      grid-column-end: 2;
    }
  }
}
</style>
